/**
 * Created by Kristy on 21/7/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hospitalizationsComparisonReport', {
                parent: 'adminIndex',
                url: '/hospitalizations/comparisonReport',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/hospitalizationsComparisonReport/hospitalizationsComparisonReport.html',
                        controller: 'HospitalizationsComparisonReportController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('hospitalization');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
